import { memo } from 'react';

interface IWriteLyricsIconProps {
  className?: string;
}

const WriteLyricsIcon: React.FC<IWriteLyricsIconProps> = memo(
  ({ className }) => (
    <svg
      className={className}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 12.0001L3 33.0001M27 22.5001H13.5M9.9 28.5001H20.0059C20.3728 28.5001 20.5562 28.5001 20.7288 28.4587C20.8819 28.4219 21.0282 28.3613 21.1624 28.2791C21.3138 28.1863 21.4435 28.0566 21.7029 27.7972L29.25 20.2501C29.6084 19.8917 29.7877 19.7124 29.9319 19.5538C33.0521 16.1211 33.0521 10.8791 29.9319 7.44645C29.7877 7.28777 29.6084 7.10855 29.25 6.75011C28.8916 6.39166 28.7123 6.21244 28.5537 6.06821C25.121 2.94797 19.879 2.94797 16.4463 6.06821C16.2877 6.21244 16.1084 6.39166 15.75 6.7501L8.20294 14.2972C7.94352 14.5566 7.8138 14.6863 7.72104 14.8377C7.6388 14.9719 7.57819 15.1182 7.54145 15.2713C7.5 15.4439 7.5 15.6273 7.5 15.9942V26.1001C7.5 26.9402 7.5 27.3602 7.66349 27.6811C7.8073 27.9633 8.03677 28.1928 8.31901 28.3366C8.63988 28.5001 9.05992 28.5001 9.9 28.5001Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
);

export { WriteLyricsIcon };
